import { CardBillingListStatus } from "@affinitysystemsgroup/assurehub-ui";
import { formatCollectionListDate, getCollectionTypeLabel, } from "../../../../../model/collection";
var STATUS_RAW_TO_CARD_STATUS = {
    BANK_PAYMENT_PENDING: CardBillingListStatus.BankPaymentPending,
    PROCESSING_BANK_FILE: CardBillingListStatus.ProcessingBankFile,
    GENERATING_BANK_FILE: CardBillingListStatus.GeneratingBankFile,
    COMPLETED: CardBillingListStatus.Completed,
    FAILED: CardBillingListStatus.Failed,
};
export var useCollectionList = function (props) {
    var cards = props.items.map(function (item) { return ({
        id: item.id,
        title: "".concat(getCollectionTypeLabel(item.billingType), " \u00B7 ").concat(formatCollectionListDate(item.createdAt)),
        status: STATUS_RAW_TO_CARD_STATUS[item.statusRaw],
        active: item.id === props.selectedId,
    }); });
    return {
        cards: cards,
        onSelect: props.onSelect,
        page: props.page,
        limit: props.limit,
        totalItems: props.totalItems,
        onChangePage: props.onChangePage,
    };
};
